import React from 'react';
import { Message } from 'rsuite';
import { Link } from 'react-router-dom';
import { settingsPortalPantryPath } from '../../../../routes/Paths';

const SetupPantryMessage = () => (
  <Message
    showIcon
    type="info"
    title="Pantry Setup Required"
    style={{ marginBottom: 16 }}
    description={
      <p>
        You must complete your Pantry details before setting up your SMTP
        account.{' '}
        <Link to={settingsPortalPantryPath}>Go to Pantry Settings</Link>
      </p>
    }
  />
);

export default SetupPantryMessage;
